export default __webpack_public_path__ + "static/media/BURAK.496dc8da.png";